(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// Includes
require('./components/enabler')
require('./components/repeater')
require('./components/instagram-account')



// --------------------------------
// App
// --------------------------------

var instagramOptions = new Vue({
    el:'#instagramOptions',
    data: {
        heading: "Instagram",
        description: "Connect Multiple Instagram Accounts",
        loading: true,
        error: null,
        data: {},
        originalData: {},
        hasUnsavedData: false
    },
    methods: {
        getOptions(){
           
            this.loading = true;
            let self = this;
 
            // Set Route
            fetch('/api/v1/instagram/options')
            .then(response => response.json())
            .then(response => {
                this.loading = false;
                if(response.success == true){

                    if(!response.data.access) response.data.access = [];

                    self.data = response.data;
                    self.originalData = response.data;
                } else {
                    console.log(response,"THERE WAS AN ERROR")
                }

            })
            .catch(e => {
                this.loading = false;
                console.log(e,"THERE WAS AN ERROR")
            })
        },
        onEnablerChanged(value){
            this.data.enabled = value;
            this.hasUnsavedData = true;
        },
        onAccessChanged(value){
            this.data.access = value;
            this.hasUnsavedData = true;
        },
        handleSave(){

            let self = this;
            this.loading = true;
            let payload = {
                enabled: this.data.enabled,
                access: this.data.access
            }

            fetch('/api/v1/instagram/options/save',{
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify(payload)
           })
            .then(response => response.json())
            .then(response => {
                this.loading = false;
                if(response.success == true){

                    if(!response.data.access) response.data.access = [];

                    self.data = response.data;
                    self.originalData = response.data;
                } else {
                    console.log(response,"THERE WAS AN ERROR")
                }

            })
            .catch(e => {
                this.loading = false;
                console.log(e,"THERE WAS AN ERROR")
            })
        }
    },
    mounted(){
        this.getOptions();
    },
});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/vue/instagram-options.js","/vue")